/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'charge': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M511.932.41C229.649.41.785 229.547.785 512.205.785 794.829 229.615 1024 511.932 1024c282.282 0 511.18-229.137 511.18-511.795S794.283.41 511.933.41zm210.5 421.478v60.177H542.037v120.457h180.395v60.177H542.037v180.633h-60.143V662.7H301.466v-60.177H481.86V482.065H301.466v-60.177h134.758l-134.758-134.93 45.636-45.704 164.83 165.035 164.83-165.035 45.636 45.74-134.759 134.894h134.827z"/>'
  }
})
